module.exports = __webpack_public_path__ + "static/media/texpert-img2.500a8f41.jpg";